import { all, fork } from 'redux-saga/effects';
import authSagas from './auth/sagas';
import reportSagas from './report/sagas';

export default function* rootSagas() {
  yield all([fork(authSagas), fork(reportSagas)]);
}
